class ProductInCart extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector("[data-close]");
    this.viewCartButton = this.querySelector("[data-view-cart]");
    this.checkoutLinkButton = this.querySelector("[data-checkout-link]");
  }

  connectedCallback() {
    document.addEventListener(
      "cart:updated",
      () => {
        const firstVisit = sessionStorage.getItem("firstVisit");

        if (firstVisit === null) {
          sessionStorage.setItem("firstVisit", "true");
        } else {
          return;
        }

        if (window.cartData.items.length == 0) return;

        this.classList.remove("hidden");
        this.setupEventListeners();
      },
      { once: true }, // Only listen once since we only check on first page load
    );
  }

  setupEventListeners() {
    this.closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.classList.add("hidden");
    });

    this.viewCartButton.addEventListener("click", () => {
      this.classList.add("hidden");
    });

    this.checkoutLinkButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.classList.add("hidden");
      window.location.href = window.cartData.checkout_url;
    });
  }
}

customElements.define("product-in-cart", ProductInCart);
